// ============================================================
// SAC - Page "RDV planifiés" (workflow=rdv_planifie)
// ------------------------------------------------------------
// Commandes deja attribuees a un agent logistique (Nathalie, Marie...)
// et pretes a etre attribuees a un repartiteur.
// Etape 2 sur 3. Chaque agent voit uniquement ses propres commandes
// (scope=mine). Admin/super_admin voient tout.
// ============================================================
import React from 'react';
import { Inbox, CalendarCheck2, Users, Route } from 'lucide-react';
import SacGridView from '../components/SacGridView';

const SAC_TABS = [
  { href: '/admin/service-client/a-planifier', label: 'RDV à planifier', icon: Inbox, active: false },
  { href: '/admin/route-optimisation',         label: 'Route Optimisation', icon: Route, active: false },
  { href: '/admin/service-client/planifies',   label: 'RDV planifiés',   icon: CalendarCheck2, active: true },
  { href: '/admin/service-client/attribuees',  label: 'Attribuées au répartiteur', icon: Users, active: false },
];

const SacPlanifiesPage = () => (
  <SacGridView
    title="RDV PLANIFIÉS"
    subtitle="Vos commandes en cours de préparation avant attribution au dispatch"
    iconLetters="SC"
    iconColor="blue"
    workflowIn={['rdv_planifie']}
    assignmentType="dispatcher"
    nextWorkflow={null}
    nextWorkflowLabel={null}
    scopeMine
    subTabs={SAC_TABS}
    storageKey="sacGrid.planifies"
  />
);

export default SacPlanifiesPage;
